// import React, { useState, useEffect, useRef } from "react";
// import "./tableStyle.css";
// import {
//   reportsApi,
//   deleteOrderbyAdmin,
//   exportFreightPaymentRegisterExcel,
// } from "../../Services/Services";
// import { Col, Input, Button, Form, message, Popconfirm, Select, Modal, Checkbox, Row } from "antd";
// import { useReactToPrint } from "react-to-print";
// import { DeleteOutlined, SettingOutlined } from "@ant-design/icons";
// import { FaFilePdf, FaFileExcel } from "react-icons/fa";
// import FreightPaymentRegisterUpdate from "./FreightPaymentRegisterUpdate";
// import InfiniteScroll from "react-infinite-scroll-component";
// import { debounce } from "../util.js";
// import { Link } from "react-router-dom";

// const { Option } = Select;

// export default function FreightPaymentRegister({ onChange }) {
//   // State management
//   const [deliveryOrder, setDeliveryOrder] = useState([]);
//   const [filterOrder, setFilterOrder] = useState(null);
//   const [hasMore, setHasMore] = useState(true);
//   const [offset, setOffset] = useState(0);
//   const [exporting, setExporting] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [columnModalVisible, setColumnModalVisible] = useState(false);

//   const limit = 50;
//   const [form] = Form.useForm();
//   const componentRef = useRef();

//   const currentYear = new Date().getFullYear();
//   const [selectedYear, setSelectedYear] = useState(currentYear);

//   const [filters, setFilters] = useState({
//     do_no: "",
//     vehicle_no: "",
//     check_no: "",
//     check_date: "",
//     year: currentYear,
//     freight_rate:""
//   });

//   // Column visibility state
//   const [visibleColumns, setVisibleColumns] = useState({
//     sr_no: true,
//     do_no: true,
//     vehicle_no: true,
//     dispatch_qty: true,
//     received_qty: true,
//     freight_qty: true,
//     sort_qty: true,
//     moisture_per: true,
//     actual_qty: true,
//     moisture_deduct_qty: true,
//     moisture_amt: true,
//     moisture_deduct: true,
//     sort_amount: true,
//     freight_rate: true,
//     freight_amt: true,
//     tds_per: true,
//     tds_amt: true,
//     advance_amt: true,
//     commission_amt: true,
//     pay_amt: true,
//     party_name: true,
//     truck_owner_name: true,
//     mines_name: true,
//     pan_no: true,
//     dispatch_date: true,
//     received_date: true,
//     check_no_col: true,
//     check_date_col: true,
//     bank_name: true,
//     ifsc_code: true,
//     account_no: true,
//     aadhar_no: true,
//     o_id: true,
//     do_qty: true,
//     do_start: true,
//     do_end: true,
//     update_col: true,
//     delete_col: true,
//   });

//   // Column configuration
//   const columnConfig = [
//     { key: "sr_no", label: "Sr. No", width: "80px" },
//     { key: "do_no", label: "DO No", width: "100px" },
//     { key: "vehicle_no", label: "Vehicle No", width: "120px" },
//     { key: "dispatch_qty", label: "Dispatch Qty", width: "110px" },
//     { key: "received_qty", label: "Received Qty", width: "110px" },
//     { key: "freight_qty", label: "Freight Qty", width: "110px" },
//     { key: "sort_qty", label: "Sort Qty", width: "100px" },
//     { key: "moisture_per", label: "Moisture %", width: "100px" },
//     { key: "actual_qty", label: "Actual Qty", width: "100px" },
//     { key: "moisture_deduct_qty", label: "Moisture Deduct Qty", width: "140px" },
//     { key: "moisture_amt", label: "Moisture Amt", width: "110px" },
//     { key: "moisture_deduct", label: "Moisture Deduct", width: "130px" },
//     { key: "sort_amount", label: "Sort Amount", width: "110px" },
//     { key: "freight_rate", label: "Freight Rate", width: "110px" },
//     { key: "freight_amt", label: "Freight Amt", width: "110px" },
//     { key: "tds_per", label: "TDS %", width: "90px" },
//     { key: "tds_amt", label: "TDS Amt", width: "100px" },
//     { key: "advance_amt", label: "Advance Amt", width: "110px" },
//     { key: "commission_amt", label: "Commission Amt", width: "130px" },
//     { key: "pay_amt", label: "Pay Amt", width: "100px" },
//     { key: "party_name", label: "Party Name", width: "150px" },
//     { key: "truck_owner_name", label: "Truck Owner Name", width: "150px" },
//     { key: "mines_name", label: "Mines Name", width: "150px" },
//     { key: "pan_no", label: "Pan No", width: "100px" },
//     { key: "dispatch_date", label: "Dispatch Date", width: "120px" },
//     { key: "received_date", label: "Received Date", width: "120px" },
//     { key: "check_no_col", label: "Check No", width: "100px" },
//     { key: "check_date_col", label: "Check Date", width: "110px" },
//     { key: "bank_name", label: "Bank Name", width: "150px" },
//     { key: "ifsc_code", label: "IFSC Code", width: "120px" },
//     { key: "account_no", label: "Account No", width: "150px" },
//     { key: "aadhar_no", label: "Aadhar No", width: "120px" },
//     { key: "o_id", label: "O. Id", width: "80px" },
//     { key: "do_qty", label: "DO Qty.", width: "100px" },
//     { key: "do_start", label: "DO Start", width: "110px" },
//     { key: "do_end", label: "DO End", width: "110px" },
//   ];

//   // Generate years array
//   const getYearsArray = (startYear, endYear) => {
//     const years = [];
//     for (let year = startYear; year <= endYear; year++) {
//       years.push(year);
//     }
//     return years;
//   };
//   const years = getYearsArray(2023, currentYear);

//   // Initial load
//   useEffect(() => {
//     fetchMoreData(0, filters);
//   }, []);

//   // Fetch data from API
//   const fetchMoreData = async (
//     newOffset = offset,
//     appliedFilters = filters
//   ) => {
//     try {
//       setLoading(true);

//       const response = await reportsApi({
//         report_name: "freight_payment_register",
//         com_name: localStorage.getItem("com_name"),
//         limit,
//         offset: newOffset,
//         year: appliedFilters.year || "",
//         do_no: appliedFilters.do_no || "",
//         vehicle_no: appliedFilters.vehicle_no || "",
//         check_no: appliedFilters.check_no || "",
//         check_date: appliedFilters.check_date || "",
//         freight_rate:appliedFilters.freight_rate || "",
//       });

//       if (response && response.results) {
//         const filteredArray =
//           localStorage.getItem("user_type") === "Lifter"
//             ? response.results.filter(
//               (o) => o.lifter_id == localStorage.getItem("user_id")
//             )
//             : response.results;

//         setDeliveryOrder((prev) =>
//           newOffset === 0 ? filteredArray : [...prev, ...filteredArray]
//         );

//         setOffset(newOffset + filteredArray.length);
//         setHasMore(response.next !== null);
//       } else {
//         if (newOffset === 0) {
//           setDeliveryOrder([]);
//         }
//         setHasMore(false);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       message.error("Failed to load data");
//       setHasMore(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Debounced filter function
//   const debouncedFilter = useRef(
//     debounce((updatedFilters) => {
//       setOffset(0);
//       setDeliveryOrder([]);
//       setHasMore(true);
//       fetchMoreData(0, updatedFilters);
//     }, 800)
//   ).current;

//   // Handle filter changes
//   const handleFilterChange = (changedValues, allValues) => {
//     const updatedFilters = { ...allValues, year: selectedYear };
//     setFilters(updatedFilters);
//     debouncedFilter(updatedFilters);
//   };

//   // Handle year change
//   const handleYearChange = (value) => {
//     setSelectedYear(value);
//     const updatedFilters = { ...filters, year: value };
//     setFilters(updatedFilters);
//     debouncedFilter(updatedFilters);
//   };

//   // Handle column visibility change
//   const handleColumnVisibilityChange = (key, checked) => {
//     setVisibleColumns((prev) => ({
//       ...prev,
//       [key]: checked,
//     }));
//   };

//   // Select all columns
//   const selectAllColumns = () => {
//     const allTrue = {};
//     Object.keys(visibleColumns).forEach(key => {
//       allTrue[key] = true;
//     });
//     setVisibleColumns(allTrue);
//   };

//   // Deselect all columns
//   const deselectAllColumns = () => {
//     const allFalse = {};
//     Object.keys(visibleColumns).forEach(key => {
//       allFalse[key] = false;
//     });
//     setVisibleColumns(allFalse);
//   };

//   // Print handler
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//   });

//   // Export to Excel using backend endpoint
//   const handleExportToExcel = async () => {
//     try {
//       setExporting(true);

//       message.loading({
//         content: "Generating Excel file...",
//         key: "export",
//         duration: 0,
//       });

//       console.log("Starting export with filters:", filters);

//       const response = await exportFreightPaymentRegisterExcel({
//         com_name: localStorage.getItem("com_name"),
//         year: selectedYear,
//         do_no: filters.do_no,
//         vehicle_no: filters.vehicle_no,
//         check_no: filters.check_no,
//         check_date: filters.check_date,
//         freight_rate:filters.freight_rate,
//       });

//       // Extract filename from headers
//       let filename = `Freight_Payment_Register_${selectedYear}.xlsx`;
//       const disposition = response.headers?.["content-disposition"];

//       if (disposition) {
//         const match = disposition.match(/filename[^;=\n]*="?([^";\n]+)"?/);
//         if (match && match[1]) {
//           filename = match[1].replace(/['"]/g, "");
//         }
//       }

//       console.log("Download filename:", filename);

//       // Create download link
//       const url = window.URL.createObjectURL(response.data);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = filename;
//       link.style.display = "none";

//       document.body.appendChild(link);
//       link.click();

//       // Cleanup
//       setTimeout(() => {
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//         console.log("Cleanup completed");
//       }, 100);

//       message.success({
//         content: `Excel file downloaded successfully!`,
//         key: "export",
//         duration: 3,
//       });
//     } catch (error) {
//       message.error({
//         content: error.message || "Failed to export Excel file",
//         key: "export",
//         duration: 5,
//       });
//     } finally {
//       setExporting(false);
//     }
//   };

//   // Delete order handler
//   const DeleteOrder = async (id) => {
//     try {
//       const response = await deleteOrderbyAdmin(id);
//       message.success("Freight deleted successfully");

//       // Refresh data after deletion
//       setOffset(0);
//       setDeliveryOrder([]);
//       setHasMore(true);
//       fetchMoreData(0, filters);
//     } catch (error) {
//       console.error("Error deleting order:", error);
//       message.error("Failed to delete freight");
//     }
//   };

//   // Format date helper
//   const formatDate = (date) => {
//     if (!date) return "";
//     try {
//       const [year, month, day] = date.split("-");
//       return `${day}-${month}-${year}`;
//     } catch {
//       return date;
//     }
//   };

//   // Safe number formatter
//   const formatNumber = (value, decimals = 2) => {
//     const num = parseFloat(value);
//     return isNaN(num) ? "0.00" : num.toFixed(decimals);
//   };

//   // Get order details for update
//   const getOrderDetails = (id) => {
//     const order = deliveryOrder.find((o) => o.id === id);
//     setFilterOrder(order);
//     form.resetFields();
//   };

//   // Calculate totals
//   const calculateTotal = (field, decimals = 2) => {
//     const total = deliveryOrder.reduce(
//       (acc, curr) => acc + parseFloat(curr[field] || 0),
//       0
//     );
//     return total.toFixed(decimals);
//   };

//   const isAdmin = localStorage.getItem("user_type") === "Admin";

//   return (
//     <div>
//       {/* Filter Form */}
//       <Form form={form} layout="vertical" onValuesChange={handleFilterChange}>
//         <div className="grid grid-cols-1 sm:grid sm:grid-cols-7 sm:gap-2 m-auto px-5 sm:w-[70%] md:w-[100%] mb-4">
//           {/* Year Select */}
//           <Col>
//             <label>
//               <b>Select Year</b>
//             </label>
//             <Select
//               value={selectedYear}
//               onChange={handleYearChange}
//               showSearch
//               style={{ width: "100%", marginTop: "8px" }}
//               placeholder="Select Year"
//             >
//               {years.map((year) => (
//                 <Option key={year} value={year}>
//                   {year}
//                 </Option>
//               ))}
//             </Select>
//           </Col>

//           {/* DO Number Filter */}
//           <Col>
//             <Form.Item
//               name="do_no"
//               label={<b>DO No.</b>}
//               style={{ margin: 0 }}
//             >
//               <Input placeholder="Search by DO No." allowClear />
//             </Form.Item>
//           </Col>

//           {/* Vehicle Number Filter */}
//           <Col>
//             <Form.Item
//               name="vehicle_no"
//               label={<b> Vehicle No.</b>}
//               style={{ margin: 0 }}
//             >
//               <Input placeholder="Search by Vehicle No." allowClear />
//             </Form.Item>
//           </Col>
//           <Col>
//             <Form.Item
//               name="freight_rate"
//               label={<b>Freight Rate</b>}
//               style={{ margin: 0 }}
//             >
//               <Input placeholder="Search by Check No." allowClear />
//             </Form.Item>
//           </Col>
//           {/* Check Number Filter */}
//           <Col>
//             <Form.Item
//               name="check_no"
//               label={<b>Check No.</b>}
//               style={{ margin: 0 }}
//             >
//               <Input placeholder="Search by Check No." allowClear />
//             </Form.Item>
//           </Col>

//           {/* Check Date Filter */}
//           <Col>
//             <Form.Item
//               name="check_date"
//               label={<b> Check Date</b>}
//               style={{ margin: 0 }}
//             >
//               <Input type="date" />
//             </Form.Item>
//           </Col>

//           {/* Column Settings Button */}
//           <Col>
//             <div className="flex items-center justify-center mt-7">
//               <Button
//                 icon={<SettingOutlined />}
//                 onClick={() => setColumnModalVisible(true)}
//                 style={{
//                   backgroundColor: "#1890ff",
//                   color: "white",
//                   fontWeight: "600",
//                   marginRight: "8px",
//                 }}
//               >
//                 Columns
//               </Button>
//                <Button
//                 icon={<FaFileExcel />}
//                 onClick={handleExportToExcel}
//                 loading={exporting}
//                 disabled={exporting}
//                 style={{
//                   backgroundColor: "green",
//                   color: "white",
//                   fontWeight: "600",
//                 }}
//               />
//             </div>
//           </Col>

         
//         </div>
//       </Form>

//       {/* Column Settings Modal */}
//       <Modal
//         title="Select Columns to Display"
//         open={columnModalVisible}
//         onCancel={() => setColumnModalVisible(false)}
//         footer={[
//           <Button key="deselect" onClick={deselectAllColumns}>
//             Deselect All
//           </Button>,
//           <Button key="select" onClick={selectAllColumns}>
//             Select All
//           </Button>,
//           <Button key="close" onClick={() => setColumnModalVisible(false)}>
//             Apply
//           </Button>,
//         ]}
//         width={700}
//       >
//         <div style={{ maxHeight: "400px", overflowY: "auto" }}>
//           <Row gutter={[16, 16]}>
//             {columnConfig.map((column) => (
//               <Col span={8} key={column.key}>
//                 <Checkbox
//                   checked={visibleColumns[column.key]}
//                   onChange={(e) => handleColumnVisibilityChange(column.key, e.target.checked)}
//                 >
//                   {column.label}
//                 </Checkbox>
//               </Col>
//             ))}
//             {isAdmin && (
//               <>
//                 <Col span={8}>
//                   <Checkbox
//                     checked={visibleColumns.update_col}
//                     onChange={(e) => handleColumnVisibilityChange('update_col', e.target.checked)}
//                   >
//                     Update
//                   </Checkbox>
//                 </Col>
//                 <Col span={8}>
//                   <Checkbox
//                     checked={visibleColumns.delete_col}
//                     onChange={(e) => handleColumnVisibilityChange('delete_col', e.target.checked)}
//                   >
//                     Delete
//                   </Checkbox>
//                 </Col>
//               </>
//             )}
//           </Row>
//         </div>
//       </Modal>

//       {/* Table Container */}
//       <div
//         id="scrollableDiv"
//         style={{
//           maxHeight: "500px",
//           overflow: "auto",
//           position: "relative",
//         }}
//         ref={componentRef}
//       >
//         <table id="my-table" className="w-full">
//           <thead className="bg-[#151B54] w-full text-white sticky top-0 z-10">
//             <tr>
//               {visibleColumns.sr_no && <th>Sr. No</th>}
//               {visibleColumns.do_no && <th>DO No</th>}
//               {visibleColumns.vehicle_no && <th>Vehicle No</th>}
//               {visibleColumns.dispatch_qty && <th>Dispatch Qty</th>}
//               {visibleColumns.received_qty && <th>Received Qty</th>}
//               {visibleColumns.freight_qty && <th>Freight Qty</th>}
//               {visibleColumns.sort_qty && <th>Sort Qty</th>}
//               {visibleColumns.moisture_per && <th>Moisture %</th>}
//               {visibleColumns.actual_qty && <th>Actual Qty</th>}
//               {visibleColumns.moisture_deduct_qty && <th>Moisture Deduct Qty</th>}
//               {visibleColumns.moisture_amt && <th>Moisture Amt</th>}
//               {visibleColumns.moisture_deduct && <th>Moisture Deduct</th>}
//               {visibleColumns.sort_amount && <th>Sort Amount</th>}
//               {visibleColumns.freight_rate && <th>Freight Rate</th>}
//               {visibleColumns.freight_amt && <th>Freight Amt</th>}
//               {visibleColumns.tds_per && <th>TDS %</th>}
//               {visibleColumns.tds_amt && <th>TDS Amt</th>}
//               {visibleColumns.advance_amt && <th>Advance Amt</th>}
//               {visibleColumns.commission_amt && <th>Commission Amt</th>}
//               {visibleColumns.pay_amt && <th>Pay Amt</th>}
//               {visibleColumns.party_name && <th>Party Name</th>}
//               {visibleColumns.truck_owner_name && <th>Truck Owner Name</th>}
//               {visibleColumns.mines_name && <th>Mines Name</th>}
//               {visibleColumns.pan_no && <th>Pan No</th>}
//               {visibleColumns.dispatch_date && <th>Dispatch Date</th>}
//               {visibleColumns.received_date && <th>Received Date</th>}
//               {visibleColumns.check_no_col && <th>Check No</th>}
//               {visibleColumns.check_date_col && <th>Check Date</th>}
//               {visibleColumns.bank_name && <th>Bank Name</th>}
//               {visibleColumns.ifsc_code && <th>IFSC Code</th>}
//               {visibleColumns.account_no && <th>Account No</th>}
//               {visibleColumns.aadhar_no && <th>Aadhar No</th>}
//               {visibleColumns.o_id && <th>O. Id</th>}
//               {visibleColumns.do_qty && <th>DO Qty.</th>}
//               {visibleColumns.do_start && <th>DO Start</th>}
//               {visibleColumns.do_end && <th>DO End</th>}
//               {isAdmin && visibleColumns.update_col && <th>Update</th>}
//               {isAdmin && visibleColumns.delete_col && <th>Delete</th>}
//             </tr>
//           </thead>
//           <tbody>
//             {deliveryOrder.length === 0 && !loading ? (
//               <tr>
//                 <td
//                   colSpan={Object.values(visibleColumns).filter(Boolean).length}
//                   style={{
//                     textAlign: "center",
//                     padding: "20px",
//                     fontSize: "14px",
//                     color: "#999",
//                   }}
//                 >
//                   No data available
//                 </td>
//               </tr>
//             ) : (
//               deliveryOrder.map((e, index) => (
//                 <tr key={e.id}>
//                   {visibleColumns.sr_no && <td>{index + 1}</td>}
//                   {visibleColumns.do_no && (
//                     <td>
//                       <Link to={`/do-view/${e.do_id}`}>
//                         <u style={{ fontWeight: "600", color: "blue" }}>
//                           {e.do_no}
//                         </u>
//                       </Link>
//                     </td>
//                   )}
//                   {visibleColumns.vehicle_no && <td>{e.vehicle_no || ""}</td>}
//                   {visibleColumns.dispatch_qty && <td>{formatNumber(e.dispatch_quantity, 3)}</td>}
//                   {visibleColumns.received_qty && <td>{formatNumber(e.received_quantity, 3)}</td>}
//                   {visibleColumns.freight_qty && <td>{formatNumber(e.freight_quantity, 3)}</td>}
//                   {visibleColumns.sort_qty && <td>{formatNumber(e.sort_quantity, 3)}</td>}
//                   {visibleColumns.moisture_per && <td>{formatNumber(e.moisture_received_per, 2)}</td>}
//                   {visibleColumns.actual_qty && <td>{formatNumber(e.actual_quantity, 3)}</td>}
//                   {visibleColumns.moisture_deduct_qty && <td>{formatNumber(e.moisture_deduct_quantity, 3)}</td>}
//                   {visibleColumns.moisture_amt && <td>{formatNumber(e.moisture_amount, 2)}</td>}
//                   {visibleColumns.moisture_deduct && <td>{formatNumber(e.moisture_deduct, 2)}</td>}
//                   {visibleColumns.sort_amount && <td>{formatNumber(e.sort_amount, 2)}</td>}
//                   {visibleColumns.freight_rate && <td>{formatNumber(e.freight_rate, 2)}</td>}
//                   {visibleColumns.freight_amt && <td>{formatNumber(e.freight_amount, 2)}</td>}
//                   {visibleColumns.tds_per && <td>{formatNumber(e.tds_per, 2)}</td>}
//                   {visibleColumns.tds_amt && <td>{formatNumber(e.tds, 2)}</td>}
//                   {visibleColumns.advance_amt && <td>{formatNumber(e.advance, 2)}</td>}
//                   {visibleColumns.commission_amt && <td>{formatNumber(e.commision, 2)}</td>}
//                   {visibleColumns.pay_amt && <td>{formatNumber(e.pay_amount, 2)}</td>}
//                   {visibleColumns.party_name && <td>{e.client_name || ""}</td>}
//                   {visibleColumns.truck_owner_name && <td>{e.truck_owner_name || ""}</td>}
//                   {visibleColumns.mines_name && <td>{e.mines_name || ""}</td>}
//                   {visibleColumns.pan_no && <td>{e.pan_no || ""}</td>}
//                   {visibleColumns.dispatch_date && <td>{formatDate(e.date)}</td>}
//                   {visibleColumns.received_date && <td>{formatDate(e.received_date)}</td>}
//                   {visibleColumns.check_no_col && <td>{e.check_no || ""}</td>}
//                   {visibleColumns.check_date_col && <td>{formatDate(e.check_date)}</td>}
//                   {visibleColumns.bank_name && <td>{e.bank_name || ""}</td>}
//                   {visibleColumns.ifsc_code && <td>{e.ifsc_code || ""}</td>}
//                   {visibleColumns.account_no && <td>{e.account_no || ""}</td>}
//                   {visibleColumns.aadhar_no && <td>{e.aadhar_no || ""}</td>}
//                   {visibleColumns.o_id && <td>{e.id}</td>}
//                   {visibleColumns.do_qty && <td>{formatNumber(e.do_qty, 3)}</td>}
//                   {visibleColumns.do_start && <td>{formatDate(e.do_start_date)}</td>}
//                   {visibleColumns.do_end && <td>{formatDate(e.do_end_date)}</td>}
//                   {isAdmin && visibleColumns.update_col && (
//                     <td>
//                       <button
//                         onClick={() => getOrderDetails(e.id)}
//                         style={{
//                           border: "none",
//                           background: "transparent",
//                           cursor: "pointer",
//                           fontSize: "12px",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <FreightPaymentRegisterUpdate
//                           setorderList={(data) => {
//                             setDeliveryOrder(data);
//                           }}
//                           setDeliveryOrder={setDeliveryOrder}
//                           filterOrder={filterOrder}
//                         />
//                       </button>
//                     </td>
//                   )}
//                   {isAdmin && visibleColumns.delete_col && (
//                     <td>
//                       <Popconfirm
//                         title="Delete Freight"
//                         description="Are you sure you want to delete this freight?"
//                         okText="Yes"
//                         cancelText="No"
//                         onConfirm={() => DeleteOrder(e.id)}
//                         okButtonProps={{
//                           style: { backgroundColor: "#ff4d4f" },
//                         }}
//                       >
//                         <button
//                           style={{
//                             border: "none",
//                             background: "transparent",
//                             cursor: "pointer",
//                             fontSize: "14px",
//                             color: "#ff4d4f",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <DeleteOutlined />
//                         </button>
//                       </Popconfirm>
//                     </td>
//                   )}
//                 </tr>
//               ))
//             )}

//             {/* Total Row */}
//             {deliveryOrder.length > 0 && (
//               <tr style={{ backgroundColor: "#e9e9e9", fontWeight: "bold" }}>
//                 <td colSpan={Object.values(visibleColumns).filter((v, i) => i < 3 && v).length} style={{ textAlign: "center" }}>
//                   <b>TOTAL</b>
//                 </td>
//                 {visibleColumns.dispatch_qty && <td>{calculateTotal("dispatch_quantity", 3)}</td>}
//                 {visibleColumns.received_qty && <td>{calculateTotal("received_quantity", 3)}</td>}
//                 {visibleColumns.freight_qty && <td>{calculateTotal("freight_quantity", 3)}</td>}
//                 {visibleColumns.sort_qty && <td></td>}
//                 {visibleColumns.moisture_per && <td></td>}
//                 {visibleColumns.actual_qty && <td></td>}
//                 {visibleColumns.moisture_deduct_qty && <td></td>}
//                 {visibleColumns.moisture_amt && <td>{calculateTotal("moisture_amount", 2)}</td>}
//                 {visibleColumns.moisture_deduct && <td>{calculateTotal("moisture_deduct", 2)}</td>}
//                 {visibleColumns.sort_amount && <td>{calculateTotal("sort_amount", 2)}</td>}
//                 {visibleColumns.freight_rate && <td></td>}
//                 {visibleColumns.freight_amt && <td>{calculateTotal("freight_amount", 2)}</td>}
//                 {visibleColumns.tds_per && <td></td>}
//                 {visibleColumns.tds_amt && <td>{calculateTotal("tds", 2)}</td>}
//                 {visibleColumns.advance_amt && <td>{calculateTotal("advance", 2)}</td>}
//                 {visibleColumns.commission_amt && <td>{calculateTotal("commision", 2)}</td>}
//                 {visibleColumns.pay_amt && <td>{calculateTotal("pay_amount", 2)}</td>}
//                 <td colSpan={Object.values(visibleColumns).filter((v, i) => i >= 20 && v).length + (isAdmin ? (visibleColumns.update_col ? 1 : 0) + (visibleColumns.delete_col ? 1 : 0) : 0)}></td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         <InfiniteScroll
//           dataLength={deliveryOrder.length}
//           next={() => fetchMoreData(offset, filters)}
//           hasMore={hasMore}
//           scrollableTarget="scrollableDiv"
//           loader={
//             loading && deliveryOrder.length > 0 ? (
//               <div style={{ textAlign: "center", padding: "10px" }}>
//                 Loading...
//               </div>
//             ) : null
//           }
//           endMessage={
//             !loading && deliveryOrder.length > 0 ? (
//               <div
//                 style={{ textAlign: "center", padding: "10px", color: "#999" }}
//               >
//                 No more records
//               </div>
//             ) : null
//           }
//         />
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect, useRef } from "react";
import "./tableStyle.css";
import {
  reportsApi,
  deleteOrderbyAdmin,
  exportFreightPaymentRegisterExcel,
} from "../../Services/Services";
import { Col, Input, Button, Form, message, Popconfirm, Select, Modal, Checkbox, Row } from "antd";
import { useReactToPrint } from "react-to-print";
import { DeleteOutlined, SettingOutlined } from "@ant-design/icons";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import FreightPaymentRegisterUpdate from "./FreightPaymentRegisterUpdate";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "../util.js";
import { Link } from "react-router-dom";

const { Option } = Select;

export default function FreightPaymentRegister({ onChange }) {
  // State management
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [filterOrder, setFilterOrder] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);
  const [exporting, setExporting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [columnModalVisible, setColumnModalVisible] = useState(false);

  const limit = 50;
  const [form] = Form.useForm();
  const componentRef = useRef();

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const [filters, setFilters] = useState({
    do_no: "",
    vehicle_no: "",
    check_no: "",
    check_date: "",
    year: currentYear,
    freight_rate: ""
  });

  // Column visibility state - DO No के बाद Truck Owner Name और Pan No
  const [visibleColumns, setVisibleColumns] = useState({
    sr_no: true,
    do_no: true,
    truck_owner_name: true,
    pan_no: true,
    vehicle_no: true,
    dispatch_qty: true,
    received_qty: true,
    freight_qty: true,
    sort_qty: true,
    moisture_per: true,
    actual_qty: true,
    moisture_deduct_qty: true,
    moisture_amt: true,
    moisture_deduct: true,
    sort_amount: true,
    freight_rate: true,
    freight_amt: true,
    tds_per: true,
    tds_amt: true,
    advance_amt: true,
    commission_amt: true,
    pay_amt: true,
    party_name: true,
    mines_name: true,
    dispatch_date: true,
    received_date: true,
    check_no_col: true,
    check_date_col: true,
    bank_name: true,
    ifsc_code: true,
    account_no: true,
    aadhar_no: true,
    o_id: true,
    do_qty: true,
    do_start: true,
    do_end: true,
    update_col: true,
    delete_col: true,
  });

  // Column configuration - DO No के बाद Truck Owner Name और Pan No
  const columnConfig = [
    { key: "sr_no", label: "Sr. No", width: "80px" },
    { key: "do_no", label: "DO No", width: "100px" },
    { key: "truck_owner_name", label: "Truck Owner Name", width: "150px" },
    { key: "pan_no", label: "Pan No", width: "100px" },
    { key: "vehicle_no", label: "Vehicle No", width: "120px" },
    { key: "dispatch_qty", label: "Dispatch Qty", width: "110px" },
    { key: "received_qty", label: "Received Qty", width: "110px" },
    { key: "freight_qty", label: "Freight Qty", width: "110px" },
    { key: "sort_qty", label: "Sort Qty", width: "100px" },
    { key: "moisture_per", label: "Moisture %", width: "100px" },
    { key: "actual_qty", label: "Actual Qty", width: "100px" },
    { key: "moisture_deduct_qty", label: "Moisture Deduct Qty", width: "140px" },
    { key: "moisture_amt", label: "Moisture Amt", width: "110px" },
    { key: "moisture_deduct", label: "Moisture Deduct", width: "130px" },
    { key: "sort_amount", label: "Sort Amount", width: "110px" },
    { key: "freight_rate", label: "Freight Rate", width: "110px" },
    { key: "freight_amt", label: "Freight Amt", width: "110px" },
    { key: "tds_per", label: "TDS %", width: "90px" },
    { key: "tds_amt", label: "TDS Amt", width: "100px" },
    { key: "advance_amt", label: "Advance Amt", width: "110px" },
    { key: "commission_amt", label: "Commission Amt", width: "130px" },
    { key: "pay_amt", label: "Pay Amt", width: "100px" },
    { key: "party_name", label: "Party Name", width: "150px" },
    { key: "mines_name", label: "Mines Name", width: "150px" },
    { key: "dispatch_date", label: "Dispatch Date", width: "120px" },
    { key: "received_date", label: "Received Date", width: "120px" },
    { key: "check_no_col", label: "Check No", width: "100px" },
    { key: "check_date_col", label: "Check Date", width: "110px" },
    { key: "bank_name", label: "Bank Name", width: "150px" },
    { key: "ifsc_code", label: "IFSC Code", width: "120px" },
    { key: "account_no", label: "Account No", width: "150px" },
    { key: "aadhar_no", label: "Aadhar No", width: "120px" },
    { key: "o_id", label: "O. Id", width: "80px" },
    { key: "do_qty", label: "DO Qty.", width: "100px" },
    { key: "do_start", label: "DO Start", width: "110px" },
    { key: "do_end", label: "DO End", width: "110px" },
  ];

  // Generate years array
  const getYearsArray = (startYear, endYear) => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };
  const years = getYearsArray(2023, currentYear);

  // Initial load
  useEffect(() => {
    fetchMoreData(0, filters);
  }, []);

  // Fetch data from API
  const fetchMoreData = async (
    newOffset = offset,
    appliedFilters = filters
  ) => {
    try {
      setLoading(true);

      const response = await reportsApi({
        report_name: "freight_payment_register",
        com_name: localStorage.getItem("com_name"),
        limit,
        offset: newOffset,
        year: appliedFilters.year || "",
        do_no: appliedFilters.do_no || "",
        vehicle_no: appliedFilters.vehicle_no || "",
        check_no: appliedFilters.check_no || "",
        check_date: appliedFilters.check_date || "",
        freight_rate: appliedFilters.freight_rate || "",
      });

      if (response && response.results) {
        const filteredArray =
          localStorage.getItem("user_type") === "Lifter"
            ? response.results.filter(
              (o) => o.lifter_id == localStorage.getItem("user_id")
            )
            : response.results;

        setDeliveryOrder((prev) =>
          newOffset === 0 ? filteredArray : [...prev, ...filteredArray]
        );

        setOffset(newOffset + filteredArray.length);
        setHasMore(response.next !== null);
      } else {
        if (newOffset === 0) {
          setDeliveryOrder([]);
        }
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to load data");
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  // Debounced filter function
  const debouncedFilter = useRef(
    debounce((updatedFilters) => {
      setOffset(0);
      setDeliveryOrder([]);
      setHasMore(true);
      fetchMoreData(0, updatedFilters);
    }, 800)
  ).current;

  // Handle filter changes
  const handleFilterChange = (changedValues, allValues) => {
    const updatedFilters = { ...allValues, year: selectedYear };
    setFilters(updatedFilters);
    debouncedFilter(updatedFilters);
  };

  // Handle year change
  const handleYearChange = (value) => {
    setSelectedYear(value);
    const updatedFilters = { ...filters, year: value };
    setFilters(updatedFilters);
    debouncedFilter(updatedFilters);
  };

  // Handle column visibility change
  const handleColumnVisibilityChange = (key, checked) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  // Select all columns
  const selectAllColumns = () => {
    const allTrue = {};
    Object.keys(visibleColumns).forEach(key => {
      allTrue[key] = true;
    });
    setVisibleColumns(allTrue);
  };

  // Deselect all columns
  const deselectAllColumns = () => {
    const allFalse = {};
    Object.keys(visibleColumns).forEach(key => {
      allFalse[key] = false;
    });
    setVisibleColumns(allFalse);
  };

  // Print handler
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  // Export to Excel using backend endpoint
  const handleExportToExcel = async () => {
    try {
      setExporting(true);

      message.loading({
        content: "Generating Excel file...",
        key: "export",
        duration: 0,
      });

      console.log("Starting export with filters:", filters);

      const response = await exportFreightPaymentRegisterExcel({
        com_name: localStorage.getItem("com_name"),
        year: selectedYear,
        do_no: filters.do_no,
        vehicle_no: filters.vehicle_no,
        check_no: filters.check_no,
        check_date: filters.check_date,
        freight_rate: filters.freight_rate,
      });

      // Extract filename from headers
      let filename = `Freight_Payment_Register_${selectedYear}.xlsx`;
      const disposition = response.headers?.["content-disposition"];

      if (disposition) {
        const match = disposition.match(/filename[^;=\n]*="?([^";\n]+)"?/);
        if (match && match[1]) {
          filename = match[1].replace(/['"]/g, "");
        }
      }

      console.log("Download filename:", filename);

      // Create download link
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        console.log("Cleanup completed");
      }, 100);

      message.success({
        content: `Excel file downloaded successfully!`,
        key: "export",
        duration: 3,
      });
    } catch (error) {
      message.error({
        content: error.message || "Failed to export Excel file",
        key: "export",
        duration: 5,
      });
    } finally {
      setExporting(false);
    }
  };

  // Delete order handler
  const DeleteOrder = async (id) => {
    try {
      const response = await deleteOrderbyAdmin(id);
      message.success("Freight deleted successfully");

      // Refresh data after deletion
      setOffset(0);
      setDeliveryOrder([]);
      setHasMore(true);
      fetchMoreData(0, filters);
    } catch (error) {
      console.error("Error deleting order:", error);
      message.error("Failed to delete freight");
    }
  };

  // Format date helper
  const formatDate = (date) => {
    if (!date) return "";
    try {
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    } catch {
      return date;
    }
  };

  // Safe number formatter
  const formatNumber = (value, decimals = 2) => {
    const num = parseFloat(value);
    return isNaN(num) ? "0.00" : num.toFixed(decimals);
  };

  // Get order details for update
  const getOrderDetails = (id) => {
    const order = deliveryOrder.find((o) => o.id === id);
    setFilterOrder(order);
    form.resetFields();
  };

  // Calculate totals
  const calculateTotal = (field, decimals = 2) => {
    const total = deliveryOrder.reduce(
      (acc, curr) => acc + parseFloat(curr[field] || 0),
      0
    );
    return total.toFixed(decimals);
  };

  const isAdmin = localStorage.getItem("user_type") === "Admin";

  return (
    <div>
      {/* Filter Form */}
      <Form form={form} layout="vertical" onValuesChange={handleFilterChange}>
        <div className="grid grid-cols-1 sm:grid sm:grid-cols-8 sm:gap-2 m-auto px-5 sm:w-[70%] md:w-[100%] mb-4">
          {/* Year Select */}
          <Col>
            <label>
              <b>Select Year</b>
            </label>
            <Select
              value={selectedYear}
              onChange={handleYearChange}
              showSearch
              style={{ width: "100%", marginTop: "8px" }}
              placeholder="Select Year"
            >
              {years.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </Col>

          {/* DO Number Filter */}
          <Col>
            <Form.Item
              name="do_no"
              label={<b>DO No.</b>}
              style={{ margin: 0 }}
            >
              <Input placeholder="Search by DO No." allowClear />
            </Form.Item>
          </Col>

          {/* Vehicle Number Filter */}
          <Col>
            <Form.Item
              name="vehicle_no"
              label={<b>Vehicle No.</b>}
              style={{ margin: 0 }}
            >
              <Input placeholder="Search by Vehicle No." allowClear />
            </Form.Item>
          </Col>

          {/* Freight Rate Filter */}
          <Col>
            <Form.Item
              name="freight_rate"
              label={<b>Freight Rate</b>}
              style={{ margin: 0 }}
            >
              <Input placeholder="Search by Freight Rate" allowClear />
            </Form.Item>
          </Col>

          {/* Check Number Filter */}
          <Col>
            <Form.Item
              name="check_no"
              label={<b>Check No.</b>}
              style={{ margin: 0 }}
            >
              <Input placeholder="Search by Check No." allowClear />
            </Form.Item>
          </Col>

          {/* Check Date Filter */}
          <Col>
            <Form.Item
              name="check_date"
              label={<b>Check Date</b>}
              style={{ margin: 0 }}
            >
              <Input type="date" />
            </Form.Item>
          </Col>

          {/* Column Settings Button */}
          <Col>
            <div className="flex items-center justify-center mt-7">
              <Button
                icon={<SettingOutlined />}
                onClick={() => setColumnModalVisible(true)}
                style={{
                  backgroundColor: "#1890ff",
                  color: "white",
                  fontWeight: "600",
                  marginRight: "8px",
                }}
              >
                Columns
              </Button>
            </div>
          </Col>

          {/* Action Buttons */}
          <Col>
            <div className="flex items-center justify-center gap-4 mt-7">
              <Button
                icon={<FaFilePdf />}
                onClick={handlePrint}
                style={{
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "600",
                  marginRight: "8px",
                }}
              />

              <Button
                icon={<FaFileExcel />}
                onClick={handleExportToExcel}
                loading={exporting}
                disabled={exporting}
                style={{
                  backgroundColor: "green",
                  color: "white",
                  fontWeight: "600",
                }}
              />
            </div>
          </Col>
        </div>
      </Form>

      {/* Column Settings Modal */}
      <Modal
        title="Select Columns to Display"
        open={columnModalVisible}
        onCancel={() => setColumnModalVisible(false)}
        footer={[
          <Button key="deselect" onClick={deselectAllColumns}>
            Deselect All
          </Button>,
          <Button key="select"  onClick={selectAllColumns}>
            Select All
          </Button>,
          <Button key="close" onClick={() => setColumnModalVisible(false)}>
            Apply
          </Button>,
        ]}
        width={700}
      >
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          <Row gutter={[16, 16]}>
            {columnConfig.map((column) => (
              <Col span={8} key={column.key}>
                <Checkbox
                  checked={visibleColumns[column.key]}
                  onChange={(e) => handleColumnVisibilityChange(column.key, e.target.checked)}
                >
                  {column.label}
                </Checkbox>
              </Col>
            ))}
            {isAdmin && (
              <>
                <Col span={8}>
                  <Checkbox
                    checked={visibleColumns.update_col}
                    onChange={(e) => handleColumnVisibilityChange('update_col', e.target.checked)}
                  >
                    Update
                  </Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox
                    checked={visibleColumns.delete_col}
                    onChange={(e) => handleColumnVisibilityChange('delete_col', e.target.checked)}
                  >
                    Delete
                  </Checkbox>
                </Col>
              </>
            )}
          </Row>
        </div>
      </Modal>

      {/* Table Container */}
      <div
        id="scrollableDiv"
        style={{
          maxHeight: "500px",
          overflow: "auto",
          position: "relative",
        }}
        ref={componentRef}
      >
        <table id="my-table" className="w-full">
          <thead className="bg-[#151B54] w-full text-white sticky top-0 z-10">
            <tr>
              {visibleColumns.sr_no && <th>Sr. No</th>}
              {visibleColumns.do_no && <th>DO No</th>}
              {visibleColumns.truck_owner_name && <th>Truck Owner Name</th>}
              {visibleColumns.pan_no && <th>Pan No</th>}
              {visibleColumns.vehicle_no && <th>Vehicle No</th>}
              {visibleColumns.dispatch_qty && <th>Dispatch Qty</th>}
              {visibleColumns.received_qty && <th>Received Qty</th>}
              {visibleColumns.freight_qty && <th>Freight Qty</th>}
              {visibleColumns.sort_qty && <th>Sort Qty</th>}
              {visibleColumns.moisture_per && <th>Moisture %</th>}
              {visibleColumns.actual_qty && <th>Actual Qty</th>}
              {visibleColumns.moisture_deduct_qty && <th>Moisture Deduct Qty</th>}
              {visibleColumns.moisture_amt && <th>Moisture Amt</th>}
              {visibleColumns.moisture_deduct && <th>Moisture Deduct</th>}
              {visibleColumns.sort_amount && <th>Sort Amount</th>}
              {visibleColumns.freight_rate && <th>Freight Rate</th>}
              {visibleColumns.freight_amt && <th>Freight Amt</th>}
              {visibleColumns.tds_per && <th>TDS %</th>}
              {visibleColumns.tds_amt && <th>TDS Amt</th>}
              {visibleColumns.advance_amt && <th>Advance Amt</th>}
              {visibleColumns.commission_amt && <th>Commission Amt</th>}
              {visibleColumns.pay_amt && <th>Pay Amt</th>}
              {visibleColumns.party_name && <th>Party Name</th>}
              {visibleColumns.mines_name && <th>Mines Name</th>}
              {visibleColumns.dispatch_date && <th>Dispatch Date</th>}
              {visibleColumns.received_date && <th>Received Date</th>}
              {visibleColumns.check_no_col && <th>Check No</th>}
              {visibleColumns.check_date_col && <th>Check Date</th>}
              {visibleColumns.bank_name && <th>Bank Name</th>}
              {visibleColumns.ifsc_code && <th>IFSC Code</th>}
              {visibleColumns.account_no && <th>Account No</th>}
              {visibleColumns.aadhar_no && <th>Aadhar No</th>}
              {visibleColumns.o_id && <th>O. Id</th>}
              {visibleColumns.do_qty && <th>DO Qty.</th>}
              {visibleColumns.do_start && <th>DO Start</th>}
              {visibleColumns.do_end && <th>DO End</th>}
              {isAdmin && visibleColumns.update_col && <th>Update</th>}
              {isAdmin && visibleColumns.delete_col && <th>Delete</th>}
            </tr>
          </thead>
          <tbody>
            {deliveryOrder.length === 0 && !loading ? (
              <tr>
                <td
                  colSpan={Object.values(visibleColumns).filter(Boolean).length}
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontSize: "14px",
                    color: "#999",
                  }}
                >
                  No data available
                </td>
              </tr>
            ) : (
              deliveryOrder.map((e, index) => (
                <tr key={e.id}>
                  {visibleColumns.sr_no && <td>{index + 1}</td>}
                  {visibleColumns.do_no && (
                    <td>
                      <Link to={`/do-view/${e.do_id}`}>
                        <u style={{ fontWeight: "600", color: "blue" }}>
                          {e.do_no}
                        </u>
                      </Link>
                    </td>
                  )}
                  {visibleColumns.truck_owner_name && <td>{e.truck_owner_name || ""}</td>}
                  {visibleColumns.pan_no && <td>{e.pan_no || ""}</td>}
                  {visibleColumns.vehicle_no && <td>{e.vehicle_no || ""}</td>}
                  {visibleColumns.dispatch_qty && <td>{formatNumber(e.dispatch_quantity, 3)}</td>}
                  {visibleColumns.received_qty && <td>{formatNumber(e.received_quantity, 3)}</td>}
                  {visibleColumns.freight_qty && <td>{formatNumber(e.freight_quantity, 3)}</td>}
                  {visibleColumns.sort_qty && <td>{formatNumber(e.sort_quantity, 3)}</td>}
                  {visibleColumns.moisture_per && <td>{formatNumber(e.moisture_received_per, 2)}</td>}
                  {visibleColumns.actual_qty && <td>{formatNumber(e.actual_quantity, 3)}</td>}
                  {visibleColumns.moisture_deduct_qty && <td>{formatNumber(e.moisture_deduct_quantity, 3)}</td>}
                  {visibleColumns.moisture_amt && <td>{formatNumber(e.moisture_amount, 2)}</td>}
                  {visibleColumns.moisture_deduct && <td>{formatNumber(e.moisture_deduct, 2)}</td>}
                  {visibleColumns.sort_amount && <td>{formatNumber(e.sort_amount, 2)}</td>}
                  {visibleColumns.freight_rate && <td>{formatNumber(e.freight_rate, 2)}</td>}
                  {visibleColumns.freight_amt && <td>{formatNumber(e.freight_amount, 2)}</td>}
                  {visibleColumns.tds_per && <td>{formatNumber(e.tds_per, 2)}</td>}
                  {visibleColumns.tds_amt && <td>{formatNumber(e.tds, 2)}</td>}
                  {visibleColumns.advance_amt && <td>{formatNumber(e.advance, 2)}</td>}
                  {visibleColumns.commission_amt && <td>{formatNumber(e.commision, 2)}</td>}
                  {visibleColumns.pay_amt && <td>{formatNumber(e.pay_amount, 2)}</td>}
                  {visibleColumns.party_name && <td>{e.client_name || ""}</td>}
                  {visibleColumns.mines_name && <td>{e.mines_name || ""}</td>}
                  {visibleColumns.dispatch_date && <td>{formatDate(e.date)}</td>}
                  {visibleColumns.received_date && <td>{formatDate(e.received_date)}</td>}
                  {visibleColumns.check_no_col && <td>{e.check_no || ""}</td>}
                  {visibleColumns.check_date_col && <td>{formatDate(e.check_date)}</td>}
                  {visibleColumns.bank_name && <td>{e.bank_name || ""}</td>}
                  {visibleColumns.ifsc_code && <td>{e.ifsc_code || ""}</td>}
                  {visibleColumns.account_no && <td>{e.account_no || ""}</td>}
                  {visibleColumns.aadhar_no && <td>{e.aadhar_no || ""}</td>}
                  {visibleColumns.o_id && <td>{e.id}</td>}
                  {visibleColumns.do_qty && <td>{formatNumber(e.do_qty, 3)}</td>}
                  {visibleColumns.do_start && <td>{formatDate(e.do_start_date)}</td>}
                  {visibleColumns.do_end && <td>{formatDate(e.do_end_date)}</td>}
                  {isAdmin && visibleColumns.update_col && (
                    <td>
                      <button
                        onClick={() => getOrderDetails(e.id)}
                        style={{
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FreightPaymentRegisterUpdate
                          setorderList={(data) => {
                            setDeliveryOrder(data);
                          }}
                          setDeliveryOrder={setDeliveryOrder}
                          filterOrder={filterOrder}
                        />
                      </button>
                    </td>
                  )}
                  {isAdmin && visibleColumns.delete_col && (
                    <td>
                      <Popconfirm
                        title="Delete Freight"
                        description="Are you sure you want to delete this freight?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => DeleteOrder(e.id)}
                        okButtonProps={{
                          style: { backgroundColor: "#ff4d4f" },
                        }}
                      >
                        <button
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            fontSize: "14px",
                            color: "#ff4d4f",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <DeleteOutlined />
                        </button>
                      </Popconfirm>
                    </td>
                  )}
                </tr>
              ))
            )}

            {/* Total Row */}
            {deliveryOrder.length > 0 && (
              <tr style={{ backgroundColor: "#e9e9e9", fontWeight: "bold" }}>
                <td colSpan={
                  // पहले 5 कॉलम (Sr.No, DO No, Truck Owner Name, Pan No, Vehicle No) गिनें
                  (visibleColumns.sr_no ? 1 : 0) +
                  (visibleColumns.do_no ? 1 : 0) +
                  (visibleColumns.truck_owner_name ? 1 : 0) +
                  (visibleColumns.pan_no ? 1 : 0) +
                  (visibleColumns.vehicle_no ? 1 : 0)
                } style={{ textAlign: "center" }}>
                  <b>TOTAL</b>
                </td>
                {visibleColumns.dispatch_qty && <td>{calculateTotal("dispatch_quantity", 3)}</td>}
                {visibleColumns.received_qty && <td>{calculateTotal("received_quantity", 3)}</td>}
                {visibleColumns.freight_qty && <td>{calculateTotal("freight_quantity", 3)}</td>}
                {visibleColumns.sort_qty && <td></td>}
                {visibleColumns.moisture_per && <td></td>}
                {visibleColumns.actual_qty && <td></td>}
                {visibleColumns.moisture_deduct_qty && <td></td>}
                {visibleColumns.moisture_amt && <td>{calculateTotal("moisture_amount", 2)}</td>}
                {visibleColumns.moisture_deduct && <td>{calculateTotal("moisture_deduct", 2)}</td>}
                {visibleColumns.sort_amount && <td>{calculateTotal("sort_amount", 2)}</td>}
                {visibleColumns.freight_rate && <td></td>}
                {visibleColumns.freight_amt && <td>{calculateTotal("freight_amount", 2)}</td>}
                {visibleColumns.tds_per && <td></td>}
                {visibleColumns.tds_amt && <td>{calculateTotal("tds", 2)}</td>}
                {visibleColumns.advance_amt && <td>{calculateTotal("advance", 2)}</td>}
                {visibleColumns.commission_amt && <td>{calculateTotal("commision", 2)}</td>}
                {visibleColumns.pay_amt && <td>{calculateTotal("pay_amount", 2)}</td>}
                {/* बाकी कॉलम के लिए खाली cells */}
                <td colSpan={
                  Object.values(visibleColumns).filter((v, i) => {
                    // Party Name से शुरू होने वाले कॉलम
                    const columnKeys = Object.keys(visibleColumns);
                    const startIndex = columnKeys.indexOf("party_name");
                    const currentKey = columnKeys[i];
                    const importantKeys = [
                      "party_name", "mines_name", "dispatch_date", "received_date",
                      "check_no_col", "check_date_col", "bank_name", "ifsc_code",
                      "account_no", "aadhar_no", "o_id", "do_qty", "do_start", "do_end"
                    ];
                    return importantKeys.includes(currentKey) && visibleColumns[currentKey];
                  }).length +
                  (isAdmin ? (visibleColumns.update_col ? 1 : 0) + (visibleColumns.delete_col ? 1 : 0) : 0)
                }></td>
              </tr>
            )}
          </tbody>
        </table>
        <InfiniteScroll
          dataLength={deliveryOrder.length}
          next={() => fetchMoreData(offset, filters)}
          hasMore={hasMore}
          scrollableTarget="scrollableDiv"
          loader={
            loading && deliveryOrder.length > 0 ? (
              <div style={{ textAlign: "center", padding: "10px" }}>
                Loading...
              </div>
            ) : null
          }
          endMessage={
            !loading && deliveryOrder.length > 0 ? (
              <div
                style={{ textAlign: "center", padding: "10px", color: "#999" }}
              >
                No more records
              </div>
            ) : null
          }
        />
      </div>
    </div>
  );
}